// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1F_3z","colBig":"styles_colBig__NwqI2","colSmall":"styles_colSmall__1nRx3"};